<template>
    <div class="order-wrapper" v-loading="loading" element-loading-text="拼命加载中">
        <div class="section-wrapper">
            <order_head :order="orderData" :check_type="check_type"></order_head>
            <el-tabs  type="border-card" class="order-detail-section mg20"
                      v-model="activeTab">
                <el-tab-pane label="财务信息" v-if="$route.query['flow_type']==params.FINANCE_LINE" name="2">
                    <order_line :order.sync="orderData" :type="orderData.type" :tab="params.FINANCE_LINE"></order_line>
                </el-tab-pane>
                <el-tab-pane label="合同附件" v-if="$route.query['flow_type']==params.CONTRACT_LINE" name="3">
                    <order_line  :order.sync="orderData" :type="orderData.type" :tab="params.CONTRACT_LINE"></order_line>
                </el-tab-pane>
            </el-tabs>
            <el-tabs v-if="orderData" type="border-card" class="order-detail-section mg20" v-model="activeName">
                <el-tab-pane label="详细信息" name="1">
                    <div>
                        <div>申请人：{{orderData.close_exec}}</div>
                        <div>申请时间：{{orderData.close_apply_time?orderData.close_apply_time:orderData.updated_at}}</div>
                        <div>关闭类型：{{orderData.close_type_memo}}</div>
                        <div>关闭原因：{{orderData.close_reason}}</div>
                        <el-row v-if="orderData.closeAttachment">
                            附件：
                            <el-row class="userInfo-group" v-for="(item, index) in orderData.closeAttachment" :key="item.id">
                                <el-row>
                                    <el-col :span="12" class="order-item"><a :href="item.url" target="_blank"><i
                                            class="el-icon-document"></i>{{item.name}}</a></el-col>
                                </el-row>
                            </el-row>
                        </el-row>
                    </div>
                </el-tab-pane>
            </el-tabs>
            <product-basic-info  :order.sync="orderData"></product-basic-info>
            <order_contract_time :order.sync="orderData"></order_contract_time>
            <order_performance v-if="orderData.finance" :order.sync="orderData"></order_performance>
            <order_scale :order.sync="orderData"></order_scale>
            <order_plan_pay :order.sync="orderData"></order_plan_pay>
            <div class="order-detail-section mg20"
                 v-if="orderData.finance && orderData.finance.express && orderData.finance.invoice && orderData.type != params.TYPE_TRY_OUT">
                <h3>其他信息</h3>
                <div class="order-userInfo">
                    <order_invoice :order.sync="orderData"></order_invoice>
                </div>
            </div>
            <order_contract v-if="orderData.contracts && orderData.contracts.length > 0" :order="orderData"></order_contract>
        </div>
    </div>
</template>
<script>
    import Params from "~/config/params";
    import {OrderMixin} from "~/services/OrderMixin";
    import order_head from "~/views/order/partial/order_head.vue";
    import order_line from "~/views/order/partial/order_line.vue";
    import Order_progress from "~/views/order/partial/order_progress.vue";
    import Order_product from "~/views/order/partial/order_product.vue";
    import order_contract from "~/views/order/partial/order_contract.vue";
    import order_invoice from "~/views/order/partial/order_invoice.vue";
    import order_address from "~/views/order/partial/order_address.vue";
    import order_logistic from "~/views/order/partial/order_logistic.vue";
    import order_plan_pay from "~/views/order/partial/order_plan_pay.vue";
    import order_customer_info from "~/views/order/partial/order_customer_info.vue";
    import order_performance from "~/views/order/partial/order_performance.vue";
    import order_finance_other from "~/views/order/partial/order_finance_other.vue";
    import order_contract_time from "~/views/order/partial/order_contract_time.vue";
    import order_scale from "~/views/order/partial/order_scale.vue";

    export default {
        mixins:[OrderMixin],
        data() {
            return {
                activeName:"1"
            };
        },
        components: {
            order_head,
            order_line,
            Order_product,
            Order_progress,
            order_contract,
            order_invoice,
            order_address,
            order_logistic,
            order_plan_pay,
            order_customer_info,
            order_performance,
            order_finance_other,
            order_contract_time,
            order_scale
        },
        methods: {
        },
        mounted() {
            this.params = Params;
            this.$nextTick(function () {
                this.getOrder(this.id);
            });

        }
    }
</script>




// WEBPACK FOOTER //
// src/views/order/approve/closeOrder.vue